<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userId" label="作者id">
          <a-input placeholder="请输入作者id" v-model="model.userId" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="title" label="标题">
          <a-input placeholder="请输入标题" v-model="model.title" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="content" label="内容">
          <a-input placeholder="请输入内容" v-model="model.content" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imageUrl" label="图片链接">
          <a-input placeholder="请输入图片链接" v-model="model.imageUrl" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="videoUrl" label="视频链接">
          <a-input placeholder="请输入视频链接" v-model="model.videoUrl" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="videoTag" label="文章类别
1.心理健康
2.家庭教育
3.专家讲座
4.亲子关系
5.情绪管理
6.育儿经验
7.安全教育
8.沟通技巧">
          <a-input-number v-model="model.videoTag"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="worksNarrate" label="作品声明 (1.取材网络  2.引用站内 3.个人观点，仅供参考 4.引用AI 5.虚构演绎，故事经历 )">
          <a-input placeholder="请输入作品声明 (1.取材网络  2.引用站内 3.个人观点，仅供参考 4.引用AI 5.虚构演绎，故事经历 )" v-model="model.worksNarrate" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="chargeStatus" label="收费状态 (0.不收费文章 1.收费文章)">
          <a-input-number v-model="model.chargeStatus"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentType" label="文章类型 (1.文章 2.视频 3.主题文章)">
          <a-input-number v-model="model.contentType"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status" label="审核状态 (0.审核中 1.已发布 2未通过 3.草稿）">
          <a-input-number v-model="model.status"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="creationType" label="创作类型 1 原创 2转载">
          <a-input-number v-model="model.creationType"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="showCount" label="展现量">
          <a-input-number v-model="model.showCount"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="viewCount" label="浏览量">
          <a-input-number v-model="model.viewCount"/>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="playBackDuration" label="播放时长">
          <a-input placeholder="请输入播放时长" v-model="model.playBackDuration" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="source" label="来源 0-PC  1-app">
          <a-input-number v-model="model.source"/>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import moment from "moment"

  export default {
    name: "ArticleModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/aigoes/article/add",
          edit: "/aigoes/article/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        //初始化默认值
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate();
      },
      handleOk () {
        const that = this;
        // 触发表单验证
         this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
             return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },


    }
  }
</script>

<style lang="less" scoped>

</style>